import React from "react";
import { PhoneCall, Mail, MessageCircle, Send } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";
import { waLink, quoteMessage } from "@/lib/whatsapp";

// Sticky mobile bottom action bar — always-accessible Call / WhatsApp / Email / Enquire.
export default function MobileActionBar() {
  const { settings } = useSettings();
  return (
    <div data-testid="mobile-action-bar" className="fixed bottom-0 left-0 right-0 z-40 md:hidden bg-pipeco-dark border-t border-white/10 grid grid-cols-4">
      <a href={`tel:${settings.whatsapp_number}`} data-testid="mba-call" className="flex flex-col items-center justify-center py-2.5 gap-0.5 text-white/85 active:bg-white/10">
        <PhoneCall size={16}/><span className="text-[9px] tracking-widest uppercase">Call</span>
      </a>
      <a href={waLink(settings.whatsapp_number, quoteMessage())} target="_blank" rel="noreferrer" data-testid="mba-wa" className="flex flex-col items-center justify-center py-2.5 gap-0.5 text-[color:var(--wa-green)] active:bg-white/10">
        <MessageCircle size={16}/><span className="text-[9px] tracking-widest uppercase">WhatsApp</span>
      </a>
      <a href={`mailto:${settings.email}`} data-testid="mba-mail" className="flex flex-col items-center justify-center py-2.5 gap-0.5 text-white/85 active:bg-white/10">
        <Mail size={16}/><span className="text-[9px] tracking-widest uppercase">Email</span>
      </a>
      <a href="/contact" data-testid="mba-enquire" className="flex flex-col items-center justify-center py-2.5 gap-0.5 bg-pipeco-green text-white active:opacity-90">
        <Send size={16}/><span className="text-[9px] tracking-widest uppercase">Enquire</span>
      </a>
    </div>
  );
}
